window.addEventListener('DOMContentLoaded', () => {
  const playerX = document.querySelector('player-x');
  if (playerX) {

    function togglePlay(player) {
      if (player.paused) {
        player.play();
      } else {
        player.pause();
      }
    }

    const playBtn = playerX.parentElement.querySelector('.bds-video__player-btn');
    playerX.addEventListener('click', () => {
      togglePlay(playerX);
    });

    playerX.addEventListener('play', () => {
      playBtn.dataset.action = 'pause';
      console.log('PlayerX playing, action:', playBtn.dataset.action);
    });

    playerX.addEventListener('pause', () => {
      playBtn.dataset.action = 'play';
      console.log('PlayerX paused, action:', playBtn.dataset.action);
    });

  }

  const vid = document.querySelector('.bds-video__asset');
  if (!vid) return;

  const testSupport = () => {
    return new Promise(resolve => {
      const timeout = setTimeout(() => resolve(false), 500); // if no play, assume fail
      const onCan = () => {
        clearTimeout(timeout);
        resolve(true);
      };
      const onError = () => {
        clearTimeout(timeout);
        resolve(false);
      };
      vid.currentTime = 0.1; // jump in
      vid.muted = true;
      vid.play().then(onCan).catch(onError);
    });
  };

  testSupport().then(ok => {
    if (!ok) {
      const sources = Array.from(vid.querySelectorAll('source'));
      const mp4 = sources.find(s => s.type === 'video/mp4');
      const first = sources[0];
      if (mp4 && first !== mp4) {
        vid.insertBefore(mp4, first);
        vid.load();
      }
    }
  });
  const players = document.querySelectorAll('.bds-video__player');

  console.log('Initializing video players:', players.length);
  for (let i = 0; i < players.length; i++) {
    const player = players[i];
    const video = player.querySelector('video');
    const playButton = player.querySelector('.bds-video__player-btn');

    playButton.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        playButton.setAttribute('data-action', 'pause');
      } else {
        video.pause();
        playButton.setAttribute('data-action', 'play');
      }
    });
  }
});

